import 'whatwg-fetch';
import 'babel-polyfill';
import { OptimizedResizeInstance } from 'js/components/Util/OptimizedResize.js';
import { SpinnerModal } from 'js/components/SpinnerModal/SpinnerModal.js';
import { LocationHours } from 'js/components/LocationHours/index.js';
import { Autocompleter } from 'js/common/modules/Autocompleter.js';
import { Maps } from 'js/components/Maps/index.js';

const Raven = require('raven-js/dist/raven.js');
Raven.config('https://13d7b1cf5db9462a8a6121dfd4d032c5@sentry.io/751790').install();
const URI = require('urijs');

import { Form } from 'js/components/Cobalt/Locator/Form.js';
import { FilterModal } from 'js/search/modules/FilterModal.js';

import { HTML5Geolocation } from 'js/components/Util/Html5Geolocation.js';
HTML5Geolocation.initClass();

let queryIsEmpty = function(query) {
  return query == "?" || query == "";
}

export class Locator {
  constructor(el, form, initialTemplate, resultsTemplate, stateChangeCallback, afterRenderCallback) {
    this.el = el;
    this.inputEl = this.el.querySelector('.js-locator-input');
    this.resultsContainer = this.el.querySelector('.js-locator-resultsContainer');
    this.form = form;
    this.stateChangeCallback = stateChangeCallback || (() => {});
    this.afterRenderCallback = afterRenderCallback || (() => {});
    this.initialTemplate = initialTemplate || (() => '<div></div>');
    this.resultsTemplate = resultsTemplate || (() => '<div></div>');

    this.spinner = new SpinnerModal();

    this.form.bindSubmitHandler(this.submitHandler.bind(this));
    window.onpopstate = this.popHandler.bind(this);

    const initAndFixAutocomplete = () => {
      new Autocompleter(document.getElementById('q'), this.el);
      window.setTimeout(() => {
        const pacContainer = document.querySelector('.pac-container');
        this.form.el.appendChild(pacContainer);
      }, 1000);
    }

    const isFrench = document.documentElement.lang.startsWith("fr") || window.location.pathname.startsWith("/fr");

    const language = isFrench ? "fr" : "en";
    const region = "CA";

    if (this.el.dataset.disableautocomplete == null) {
      if (typeof google == 'undefined') {
        const script = document.createElement('script');
        script.src= `//maps.googleapis.com/maps/api/js?v=3.31&${window.Yext.Maps.AceMap.instances[0].versionType}=${window.Yext.Maps.AceMap.instances[0].config.apiID}&language=${language}&region=${region}&libraries=places&channel=${window.Yext.Maps.AceMap.instances[0].config.channelId}&callback=window.Yext.Maps.AceMap.providerCallback`;
        script.onload = initAndFixAutocomplete;
        document.getElementsByTagName('head')[0].appendChild(script);
      } else {
        initAndFixAutocomplete();
      }
    }

    const geolocateButton = this.form.el.querySelector('.js-locator-geolocateTrigger');
    if (geolocateButton) {
      geolocateButton.addEventListener('click', () => {this.geolocate(this.inputEl)});
    }

    this.onLoad();
  }

  popHandler(evt) {
    this.render(evt.state);
    this.form.deserialize(window.location.search);
    this.stateChangeCallback();
  }

  async geolocate(input) {
    const name = input.name;
    this.spinner.showSpinner();
    HTML5Geolocation.getCurrentLocation(async (position) => {
      if (position.hasOwnProperty('latitude') && position.hasOwnProperty('longitude')) {
        const currentUrl = `${window.location.pathname}`;
        const queryString = `${name}=${position.latitude},${position.longitude}`;
        let results = null
        try {
          results = await this.search(queryString);
          const queryLocation = results.queryLocation;
          if (queryLocation) {
            input.value = `${queryLocation.city}, ${queryLocation.state} ${queryLocation.zip}`;
            window.history.pushState(results, "", `${currentUrl}?${name}=${queryLocation.city}, ${queryLocation.state} ${queryLocation.zip}`);
          } else {
            input.value = `${position.latitude},${position.longitude}`;
            window.history.pushState(results, "", `${currentUrl}?${name}=${position.latitude},${position.longitude}`);
          }
          this.render(results);
          this.spinner.hideSpinner();
        } catch(err) {
          console.log("Geolocation Error: ", err);
          Raven.captureException(err, {
            extra: {
              details: 'Error searching after geolocation',
              queryString: queryString
            }
          });
        }
      } else {
        console.log("Error: no position found.");
      }
    }, () => {
      this.spinner.hideSpinner();
      console.log("Error: no position found.");
    });
  }

  render(data) {
    if (typeof google == 'undefined') {
      const script = document.createElement('script');
      script.src=`https://maps.googleapis.com/maps/api/js?v=3.31&libraries=places&key=AIzaSyD1iQBOsWj3Su1vHjv0kaHshtdQZ5CUIA4&channel=${window.location.hostname}`;
      script.onload = () => { this.render(data) };
      return;
    }

    if (data.locations && data.locations.length) {
      data.locations.forEach(({loc}) => {
        if (loc.milesToQueryLocation) {
          // Round to 1 decimal place
          loc.milesToQueryLocation = Math.round(loc.milesToQueryLocation * 10) / 10;
        }
      })
    }

    data = Object.assign(data, this.templateParams);

    if (!data.locations) {
      this.resultsContainer.innerHTML = this.initialTemplate(data);
    } else {
      this.resultsContainer.innerHTML = this.resultsTemplate(data);
      LocationHours.loadAndRun();
    }

    this.afterRenderCallback(data);

    const locations = data ? (data.locations || []) : [];

    for (let map of Maps.instances) {
      for (let pin of map.pins || []) {
        pin.setMap(null);
      }
      map.pins = [];
      map.allLocations = locations.map(key => Object.assign(key.loc, {url: key.url, altTagText: ''}));
      if (typeof(mapboxgl) != 'undefined') {
        map.updateMap(); // TODO: this class shouldn't depend on a map
      } else {
        map.prepareMap();
      }
      map.registerClickHandlers();
    }
  }

  async onLoad() {
    const currentUrl = `${window.location.pathname}`;
    const currentQuery = window.location.search;
    const locatorConfigEl = this.el.querySelector('.js-locator-config');
    this.templateParams = locatorConfigEl ? JSON.parse(locatorConfigEl.innerHTML) : {};

    Raven.setExtraContext({
      site: this.templateParams.siteInternalHostName ? this.templateParams.siteInternalHostName : 'unknown'
    });
    if (queryIsEmpty(currentQuery)) {
      const data = JSON.parse(this.el.querySelector('.js-locator-initialData').innerHTML);
      window.history.replaceState(data,"", `${currentUrl}`);
      return;
    }

    this.form.deserialize(currentQuery);
    window.history.replaceState({},"", `${currentUrl}${currentQuery}`);
    let data = null;
    try {
      data = await this.submitAndRender();
      window.history.replaceState(data, "", `${currentUrl}${currentQuery}`);
    } catch(err) {
      console.log("err: ", err);
      Raven.captureException(err, {
        extra: {
          details: 'Initial search after deserializing from url',
          queryString: currentQuery
        }
      });
    }
    this.stateChangeCallback();
  }

  async submitHandler(evt) {
    if (evt) evt.preventDefault();
    const currentUrl = `${window.location.pathname}`;
    const query = this.form.serialize();
    let initialFormQueryMap = new URI().search(true);
    let formQueryMap = new URI(`?${query}`).search(true);
    let formParameters = this.form.getFieldsByName();
    Object.keys(initialFormQueryMap).forEach(function(key) {
      if (!(key in formQueryMap) && (key in formParameters)) {
        formQueryMap[key] = [];
      }
    });
    let currentURI = new URI().setSearch(formQueryMap);
    window.history.pushState({}, "", currentURI.toString());
    let data = null;
    try {
      data = await this.submitAndRender();
      window.history.replaceState(data, "", currentURI.toString());
    } catch(err) {
      console.log("err: ", err);
      Raven.captureException(err, {
        extra: {
          details: 'Standard search',
          queryString: query
        }
      });
    }
  }

  async submitAndRender() {
    const query = this.form.serialize();
    return this.searchAndRender(query);
  }

  async searchAndRender(query) {
    Yext.Analytics.send({eventType: 'search'});
    this.spinner.showSpinner();
    const startTime = performance.now();
    let results = await this.search(query);
    //if no results on initial search expand search to 500 miles
    if (results.locations && results.locations.length == 0) {
      results = await this.search(query, 500);
    }
    this.render(results);
    const finishTime = performance.now();
    if ((finishTime - startTime) > 500) {
      this.spinner.hideSpinner();
    } else {
      window.setTimeout(this.spinner.hideSpinner.bind(this.spinner), 500 - (finishTime - startTime));
    }
    return results
  }

  async search(query, radius = 50) {
    const fetchInit = {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
      }
    };
    try {
      const response = await fetch(`${this.form.getAction()}?${query}&r=${radius}`, fetchInit);
      return response.json();
    } catch(err) {
      Raven.captureException(err, {
        extra: {queryString: query,}
      });
      return Promise.reject(e)
    }
  }
}
